import React from "react";
import "../../../scss/components/_sidebar-modernized.scss";

interface SidebarMinimizerModernizedProps {
  toggleMinimizer?: () => void;
}

const SidebarMinimizerModernized: React.FC<SidebarMinimizerModernizedProps> = ({
  toggleMinimizer,
}) => {
  const sidebarMinimize = () => {
    const isNarrowScreen = window.innerWidth < 1400;
    const hasMinimized = document.body.classList.contains("sidebar-minimized");
    const hasFull = document.body.classList.contains("sidebar-full");

    if (isNarrowScreen) {
      // On narrow screens (< 1400px): default should be minimized
      // Toggle between minimized and full
      if (hasFull) {
        // Currently full (expanded), so minimize it
        document.body.classList.remove("sidebar-full");
        document.body.classList.add("sidebar-minimized");
      } else {
        // Currently minimized (or default), so expand it to full
        document.body.classList.remove("sidebar-minimized");
        document.body.classList.add("sidebar-full");
      }
    } else {
      // On wide screens (>= 1400px): default should be full (no classes = 155px)
      // Toggle between full and minimized
      if (hasMinimized) {
        // Currently minimized, so expand it (remove minimized, ensure no full class)
        document.body.classList.remove("sidebar-minimized");
        document.body.classList.remove("sidebar-full");
      } else {
        // Currently full (default), so minimize it
        document.body.classList.add("sidebar-minimized");
        document.body.classList.remove("sidebar-full");
      }
    }
  };

  const brandMinimize = () => {
    document.body.classList.toggle("brand-minimized");
    if (window.innerWidth < 1400) {
      document.body.classList.toggle("brand-minimized");
    }
  };

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    sidebarMinimize();
    brandMinimize();
    if (toggleMinimizer) {
      toggleMinimizer();
    }
  };

  return (
    <button
      className="sidebar-minimizer sidebar-minimizer-modernized"
      onClick={handleClick}
      aria-label="Toggle sidebar"
      type="button"
    >
      <i className="fas fa-angle-double-left" aria-hidden="true"></i>
    </button>
  );
};

export default SidebarMinimizerModernized;
